var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video"},[_c('video',{attrs:{"src":_vm.video,"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }